import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import {
  metricsQueries,
  useMetricsService,
} from "../../../services/metricsService";
import {
  assetsQueries,
  useAssetsService,
} from "../../../services/assetService";
import {
  anomaliesQueries,
  useAnomaliesService,
} from "../../../services/anomalieService";
import { useEffect, useState } from "react";

export function useReportPrintHook() {
  const { id } = useParams();
  const [showData, setShowData] = useState(false);
  const assetService = useAssetsService();
  const metricsService = useMetricsService();
  const anomaliesService = useAnomaliesService();
  const maetricsService = useMetricsService();

  const {
    data: assetData,
    isLoading: isLoadingAsset,
    isRefetching: isRefetchingAsset,
    refetch: refetchAsset,
  } = useQuery("assetsQueries.GET_BY_ID", () =>
    assetService.getAssetsById({
      // TODO Colocar dinamico
      id,
    })
  );

  const {
    data: defectMetricsData,
    isLoading: isLoadingDefectMetrics,
    isRefetching: isRefetchingDefectMetrics,
    refetch: refetchDefectMetrics,
  } = useQuery("metricsQueries.GET_ASSETS_DEFECT_TYPES_BY_CLIENT", () =>
    metricsService.getAssetsMetricsDefectTypesById({
      // TODO Colocar dinamico
      fkClientId: 1,
    })
  );

  const {
    data: generalMetricsData,
    isLoading: isLoadingMetrics,
    isRefetching: isRefetchingMetrics,
    refetch: refetchGeneralMetrics,
  } = useQuery("metricsQueries.GET_ASSETS_GENERAL_BY_CLIENT", () =>
    metricsService.getMetricsById({
      // TODO Colocar dinamico
      id: id,
    })
  );

  const {
    data: anomaliesData,
    isLoading: isLoadingAnomalies,
    isRefetching: isRefetchingAnomalies,
    refetch: refetchAnomalies,
  } = useQuery("anomaliesQueries.GET_ALL", () =>
    anomaliesService.getAllAnomalies({
      // TODO Colocar dinamico
      fkAssetId: id,
    })
  );

  const {
    data: singleMetricsData,
    isLoading: isLoadingSingleMetrics,
    isRefetching: isRefetchingSingleMetrics,
    refetch: refetchSingleMetrics,
  } = useQuery("metricsQueries.GET_SINGLE_BY_CLIENT", () =>
    maetricsService.getSingleByClient({
      // TODO Colocar dinamico
      fkClientId: 1,
    })
  );

  function getChartdata(assetData) {
    const categories =
      assetData?.dueDates?.slice(0, 4)?.map((item) => item.labelYear) || [];
    const dataValues =
      assetData?.dueDates
        ?.slice(0, 4)
        ?.map((item) => parseFloat(item.totalArea[0] / 100).toFixed(2)) || [];
    const maxValue = Math.max(...dataValues);
    const minValue = Math.min(...dataValues);

    const data = {
      categories,
      series: [
        {
          color: "#ff0000",
          data: dataValues,
        },
      ],
      maxValue,
      minValue,
    };
    return data;
  }

  useEffect(() => {
    const allLoaded =
      !isLoadingMetrics &&
      !isRefetchingMetrics &&
      !isLoadingDefectMetrics &&
      !isRefetchingDefectMetrics &&
      !isLoadingAsset &&
      !isRefetchingAsset &&
      !isLoadingAnomalies &&
      !isRefetchingAnomalies;

    if (allLoaded) {
       setShowData(true);
      setTimeout(() => {
       
        window.dispatchEvent(new Event("report-ready"));
      }, 3000);
    }
  }, [
    isLoadingMetrics,
    isRefetchingMetrics,
    isLoadingDefectMetrics,
    isRefetchingDefectMetrics,
    isLoadingAsset,
    isRefetchingAsset,
    isLoadingAnomalies,
    isRefetchingAnomalies,
  ]);

  useEffect(() => {
    document.body.classList.add("report-print-body");

    return () => {
      document.body.classList.remove("report-print-body");
    };
  }, []);

  return {
    single: {
      metricsData: singleMetricsData,
      isLoading: isLoadingSingleMetrics || isRefetchingSingleMetrics,
      refetchSingleMetrics,
    },
    assets: {
      metricsData: generalMetricsData,
      isLoading: isLoadingMetrics || isRefetchingMetrics,
      refetchGeneralMetrics,
      getChartdata,
    },
    defectTypes: {
      metricsData: defectMetricsData,
      isLoading: isLoadingDefectMetrics || isRefetchingDefectMetrics,
      refetchDefectMetrics,
    },
    selectdAsset: {
      assetData,
      isLoading: isLoadingAsset || isRefetchingAsset,
      refetchAsset,
    },
    anomalies: {
      anomaliesData,
      isLoading: isLoadingAnomalies || isRefetchingAnomalies,
      refetchAnomalies,
    },
    general: {
      showData,
    },
  };
}
